import {call, put, take} from "redux-saga/effects";
import * as types from "../../lib/actionTypes.es6";
import {
  addCustomerBeneficiaryBankDetails,
  deleteCustomerbeneficiaryBankDetails,
  getCustomerBeneficiaryBankDetails,
  updateCustomerBeneficiaryBankDetails
} from "../../lib/requests.es6";
import * as actions from "./actions.js";
import {unAuthorizedNotification} from "../../lib/access.es6";
import {GAloggerException} from "../../lib/monitoring.es6";

export function* getCustomeBeneficiaryBankDetailsRequestWatcher() {
  while (true) {
    try {
      const {payload} = yield take(types.GET_CUSTOMER_BENEFICIARY_BANK_DETAILS_REQUEST);
      const response = yield call(getCustomerBeneficiaryBankDetails, payload);
      yield put(actions.getCustomerBeneficiaryBankDetailsSuccess(response.data));
    } catch (e) {
      let errorPayload = {message: 'An error occurred, this could be due to invalid data'};
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.getCustomerBeneficiaryBankDetailsFailed(errorPayload));
      GAloggerException(e);
    }
  }
}

// export function* getCustomerBeneficiaryRequestWatcher() {
//   while (true) {
//     try {
//       const {payload} = yield take(types.GET_CUSTOMER_BENEFICIARY_REQUEST);

//       const response = yield call(getCustomerDependant, payload);
//       yield put(actions.getCustomerDependantSuccess(response.data));
//     } catch (e) {
//       let errorPayload = {message: 'An error occurred, this could be due to invalid data'};
//       if (e.response) {
//         errorPayload = e.response.data;
//         unAuthorizedNotification(e);
//       }
//       yield put(actions.getCustomerDependantFailed(errorPayload));
//       GAloggerException(e);
//     }
//   }
// }

export function* addCustomerBeneficiaryBankDetailsRequestWatcher() {
  while (true) {
    try {
      const {payload} = yield take(types.ADD_CUSTOMER_BENEFICIARY_BANK_DETAILS_REQUEST);

      const response = yield call(addCustomerBeneficiaryBankDetails, payload);
      yield put(actions.addCustomerBeneficiaryBankDetailsSuccess(response.data));
      yield put(actions.getCustomerBeneficiaryBankDetailsRequest(payload.customer_guid));
      
    } catch (e) {
      let errorPayload = {message: 'An error occurred, this could be due to invalid data'};
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.addCustomerBeneficiaryBankDetailsFailed(errorPayload));
      GAloggerException(e);
    }
  }
}

export function* updateCustomerBeneficiaryBankDetailsRequestWatcher() {
  while (true) {
    try {
      const {payload} = yield take(types.UPDATE_CUSTOMER_BENEFICIARY_BANK_DETAILS_REQUEST);

      const response = yield call(updateCustomerBeneficiaryBankDetails, payload);
      yield put(actions.updateCustomerBeneficiaryBankDetailsSuccess(response.data));
      yield put(actions.getCustomerBeneficiaryBankDetailsRequest(payload.customer_guid));
    } catch (e) {
      let errorPayload = {message: 'An error occurred, this could be due to invalid data'};
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.updateCustomerBeneficiaryBankDetailsFailed(errorPayload));
      GAloggerException(e);
    }
  }
}

export function* deleteCustomerBeneficiaryBankDetailsRequestWatcher() {
  while (true) {
    try {
      const {payload} = yield take(types.DELETE_CUSTOMER_BENEFICIARY_BANK_DETAILS_REQUEST);

      const response = yield call(deleteCustomerbeneficiaryBankDetails, payload);
      yield put(actions.deleteCustomerBeneficiaryBankDetailsSuccess(response.data));
      yield put(actions.getCustomerBeneficiaryBankDetailsRequest(payload.customer_guid));
    } catch (e) {
      let errorPayload = {message: 'An error occurred, this could be due to invalid data'};
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.deleteCustomerBeneficiaryBankDetailsFailed(errorPayload));
      GAloggerException(e);
    }
  }
}

